exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_taskDetailsCell__qtmtm{vertical-align:\"middle\"}.style_stats__MyEBG{padding-left:1rem}.style_states__1MbFc{width:16rem}", ""]);

// exports
exports.locals = {
	"taskDetailsCell": "style_taskDetailsCell__qtmtm",
	"stats": "style_stats__MyEBG",
	"states": "style_states__1MbFc"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/areas/tasks/components/Tasks/style.less
// module id = 1564
// module chunks = 8